import React, {useState, useEffect} from "react";
import {Link} from "react-router-dom";
import {t, useEnsureTranslate} from "../../../shared-services/translate";
import styled from "styled-components";
import {isEasterPeriod, isChristmasPeriod, isSilvesterPeriod} from "../../../react-helpers/dateHelper";
import useWindowTools from "../../../react-hooks/useWindowTools";
import {trackEvent} from "../../../services/tracking-helper";

const PATHS = {
  CATEGORIES_ROOT: "branding_header.main_navigation.categories_root.url",
  OFFERS: "branding_header.main_navigation.offers.url",
  WINE: "branding_header.main_navigation.wine.url",
  FARMY_FAMILY: "branding_header.main_navigation.farmy_family.url",
  BBQ: "branding_header.main_navigation.bbq.url",
  BEST_PRICE: "branding_header.main_navigation.best_price.url",
  SAVE_ME: "branding_header.main_navigation.save_me.url",
  FESTIVE_SEASON: "branding_header.main_navigation.festive_season.url",
  SILVESTER: "branding_header.main_navigation.silvester.url"
};
const TITLES = {
  CATEGORIES_ROOT: "branding_header.main_navigation.categories_root.title",
  OFFERS: "branding_header.main_navigation.offers.title",
  WINE: "branding_header.main_navigation.wine.title",
  FARMY_FAMILY: "branding_header.main_navigation.farmy_family.title",
  BBQ: "branding_header.main_navigation.bbq.title",
  BEST_PRICE_SHORT: "branding_header.main_navigation.best_price.title_short",
  SAVE_ME: "branding_header.main_navigation.save_me.title",
  FESTIVE_SEASON: "branding_header.main_navigation.festive_season.title",
  SILVESTER: "branding_header.main_navigation.silvester.title"
};

const MainNav = () => {
  useEnsureTranslate();
  const [currentMenu, setCurrentMenu] = useState([]);
  const {isMobile} = useWindowTools();

  useEffect(() => {
    const currentDate = new Date();

    let newMenu = [];
    if (isEasterPeriod(currentDate)) {
      newMenu = [
        {path: PATHS.CATEGORIES_ROOT, label: TITLES.CATEGORIES_ROOT},
        {path: PATHS.WINE, label: TITLES.WINE},
        {path: PATHS.OFFERS, label: TITLES.OFFERS},
        {path: PATHS.BEST_PRICE, label: TITLES.BEST_PRICE_SHORT},
        {path: PATHS.SAVE_ME, label: TITLES.SAVE_ME}
      ];
    } else if (isChristmasPeriod(currentDate)) {
      newMenu = [
        {path: PATHS.FESTIVE_SEASON, label: TITLES.FESTIVE_SEASON},
        {path: PATHS.OFFERS, label: TITLES.OFFERS},
        {path: PATHS.BEST_PRICE, label: TITLES.BEST_PRICE_SHORT},
        {path: PATHS.SAVE_ME, label: TITLES.SAVE_ME},
        {path: PATHS.FARMY_FAMILY, label: TITLES.FARMY_FAMILY}
      ];
    } else if (isSilvesterPeriod(currentDate)) {
      newMenu = [
        {path: PATHS.SILVESTER, label: TITLES.SILVESTER},
        {path: PATHS.OFFERS, label: TITLES.OFFERS},
        {path: PATHS.BEST_PRICE, label: TITLES.BEST_PRICE_SHORT},
        {path: PATHS.SAVE_ME, label: TITLES.SAVE_ME},
        {path: PATHS.FARMY_FAMILY, label: TITLES.FARMY_FAMILY}
      ];
    } else {
      newMenu = [
        {path: PATHS.CATEGORIES_ROOT, label: TITLES.CATEGORIES_ROOT},
        {path: PATHS.OFFERS, label: TITLES.OFFERS},
        {path: PATHS.BEST_PRICE, label: TITLES.BEST_PRICE_SHORT},
        {path: PATHS.SAVE_ME, label: TITLES.SAVE_ME},
        {path: PATHS.FARMY_FAMILY, label: TITLES.FARMY_FAMILY}
      ];
    }

    if (isMobile) {
      newMenu = newMenu.filter(item =>
        item.path === PATHS.CATEGORIES_ROOT || item.path === PATHS.OFFERS
      );
    }

    setCurrentMenu(newMenu);
  }, [isMobile]);

  // Label expected to receive is the translation key
  const trackLinkClick = (label) => {
    if (!label) return;
    const labelArray = label.split(".");
    // eslint-disable-next-line no-magic-numbers
    const labelCode = labelArray[labelArray.length - 2];
    const eventName = `navigation_${labelCode}`;
    trackEvent(eventName);
  };

  return (
    <MainNavUl>
      {currentMenu.map((item, index) => (
        <li key={index}>
          <Link to={t(item.path) || ""} onClick={() => trackLinkClick(item.label)}>{t(item.label)}</Link>
        </li>
      ))}
    </MainNavUl>
  );
};

export default MainNav;

const MainNavUl = styled.ul`
  margin-top: 17px;
  display: flex;
  align-items: center;
  flex-direction: row;
  position: absolute;
  margin-left: 165px;
  margin-bottom: 0;
  padding-left: 0;
  list-style: none;
  
  a {
    color: #333333;
    font-weight: bold;
    background: none !important;
    font-size: 16px;
    padding: 0 15px 0 0;
    
    &:hover {
      color: #F4991A;
      cursor: pointer;
    }
  }
`;
